import Blades from './blades/Blades';
import applicationDataContent from '../netBank/applicationDataContent.json';

export type BladeNameT = keyof (typeof Blades)

export type ApplicationDataT = {
    applicationNumber: string;
}
export type RootModel = typeof window.NetBank.rootModel;
export type ApplicationData = typeof window.NetBank.applicationData;
export type ApplicationDataContent = typeof applicationDataContent;
export type ReferenceData = typeof window.NetBank.applicationData.referenceData;

export const MONTHS_IN_A_YEAR = 12;
export const BORROWING_POWER_EDIT_BTN_LABEL = 'Edit';
export const BORROWING_POWER_EDIT_BTN_SPAN_LABEL = 'borrowing amount';
export const MINIMAL_SHOW_MIDDLE_MARK_THRESHOLD = 5000;
export const SECURED_LOAN_PRODUCT_TITLE = 'A lower rate';
export const UNSECURED_LOAN_PRODUCT_FIXED_TITLE = 'Fixed rate';
export const UNSECURED_LOAN_PRODUCT_VARIABLE_TITLE = 'Unlimited repayments';

export const SECURED_LOAN_PRODUCT_HEADER = 'Secured loan (Fixed)';
export const UNSECURED_LOAN_PRODUCT_FIXED_HEADER = 'Unsecured loan (Fixed)';
export const UNSECURED_LOAN_PRODUCT_VARIABLE_HEADER = 'Unsecured loan (Variable)';

export const SECURED_LOAN_PRODUCT_INTEREST_TITLE = 'Secured Personal Loan';
export const UNSECURED_LOAN_PRODUCT_FIXED_INTEREST_TITLE = 'Unsecured Personal Loan (Fixed)';
export const UNSECURED_LOAN_PRODUCT_VARIABLE_INTEREST_TITLE = 'Unsecured Personal Loan (Variable)';

export const LOAN_PRODUCT_CAPPED_MESSAGE = 'You can borrow up to {0}';
export const LOAN_PRODUCT_ITEM_CAPPED_MESSAGE = 'Maximum loan amount is {0}';
export const LOAN_PRODUCT_TOOL_TIP = 'This is an estimate only';
export const DYNAMIC_MESSAGE_LESS_THAN_MINIMUM = 'The estimates are limited to the minimum loan amount {0}';

export interface IErrorActionPayloadType {
    errorMessage: string;
    navigateToErrorPage?: boolean;
}

export type RateInfo = {
    loanOptionId: number,
    repaymentPerWeek: number,
}

export const LOAN_PURPOSE_ID = Object.freeze({
    CAR: -1,
    RENOVATIONS: -2,
    DEBT_CONSOLIDATION: -3,
    GREEN_PURCHASES: -4,
    PERSONAL_GOODS: -5,
    TRAVEL: -6,
    MEDICAL_AND_DENTAL: -7,
    OTHERS: -8,
    USED_PETROL_OR_DIESEL_MORE_THAN_7_YEARS: -38,
    NEW_ELECTRIC_HYBRID: -39,
    USED_ELECTRIC_HYBRID_LESS_THAN_7_YEARS: -40,
    USED_ELECTRIC_HYBRID_MORE_THAN_7_YEARS: -41,
    GREEN_PURCHASES_ELECTRIC_HYBRID: -43,
    INVALID: -9999,
});

export const LOAN_TYPE_NAME = Object.freeze({
    SECURED: 'SecuredLoan',
    UNSECURED_FIXED: 'FixedRate',
    UNSECURED_VARIABLE: 'VariableRate',
});

export const LOAN_TYPE_ID = Object.freeze({
    SECURED: 85,
    UNSECURED_FIXED: 84,
    UNSECURED_VARIABLE: 83,
});

export const PRODUCT_TYPE = Object.freeze({
    STANDARD: 0,
    GREEN: 1,
});

export const BLADE_NAME = Object.freeze({
    GET_STARTED: 'ApplicationStart',
    LOAN_PURPOSE: 'LoanPurposes',
    SUB_LOAN_PURPOSE: 'SubLoanPurpose',
    OTHER_SUB_LOAN_PURPOSE: 'OtherSubLoanPurpose',
    DEBT_CONSOLIDATION: 'DebtConsolidation',
    BORROWING_INPUT: 'BorrowingInput',
    BORROWING_POWER: 'BorrowingPower',
    LOAN_OPTIONS: 'LoanOptions',
    SORRY: 'Sorry',
});

export const YOUR_FINANCE_BLADE_ID = Object.freeze({
    DEBT_CONSOLIDATION: 'debt-consolidation',
    BORROWING_INPUT: 'borrowing-input',
});
export interface RefFeesAndCharges {
    interestRate: number;
    establishmentFee: number;
    monthlyServiceFee: number;
    loanTypeId: number;
    loanType: string;
}

export interface FeesAndCharges {
    interestRate: number;
    establishmentFee: number;
    monthlyServiceFee: number;
    loanTypeId: number;
    loanType: string;
    cappedAmount: number,
}

export interface LoanConfiguration {
    minimumLoanAmount: number,
    maximumLoanAmount: number,
    minimumUnsecuredLoanAmount: number,
    maximumUnsecuredLoanAmount: number,
    defaultLoanRepaymentFrequency: string,
    defaultLoanTermInYears: number
}
